import { render, staticRenderFns } from "./StudentResults.vue?vue&type=template&id=5a9b6415"
import script from "./StudentResults.vue?vue&type=script&lang=js"
export * from "./StudentResults.vue?vue&type=script&lang=js"
import style0 from "./StudentResults.vue?vue&type=style&index=0&id=5a9b6415&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports